module.exports = __webpack_public_path__ + "static/img/login.50ba8b17.png";